import {
  Link,
  Outlet,
  createRootRouteWithContext,
} from "@tanstack/react-router";
import { CssBaseline, CssVarsProvider, styled } from "@mui/joy";
import { Sidebar } from "../ui/Sidebar/Sidebar";
import { fetchSources } from "../data/sources";
import { QueryProvider } from "../context/query";

import "../styles.css";
import { SavedQueriesProvider } from "../context/savedQueries";
import { ExplicitQueryProvider } from "../context/explicitQuery";
import type { QueryClient } from "@tanstack/react-query";
import { PageWrapper } from "../ui/PageWrapper";

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: RootComponent,
  loader: async () => ({
    sources: await fetchSources(),
  }),
  staleTime: Infinity,
  pendingComponent: () => <div>Loading...</div>,
  notFoundComponent: () => (
    <PageWrapper title="404 Not Found">
      This route does not exist or was moved. <Link to="/">Go Home</Link>.
    </PageWrapper>
  ),
});

function RootComponent() {
  return (
    <CssVarsProvider>
      <QueryProvider>
        <SavedQueriesProvider>
          <ExplicitQueryProvider>
            <CssBaseline />

            <Wrapper>
              <Sidebar />
              <Main>
                <Outlet />
              </Main>
            </Wrapper>
          </ExplicitQueryProvider>
        </SavedQueriesProvider>
      </QueryProvider>
    </CssVarsProvider>
  );
}

const Wrapper = styled("div")`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const Main = styled("main")`
  flex: 1;
  overflow: auto;
`;
